export default {
  name: "question-card",
  props: {
    question: {
      type: Object,
      default: () => {},
    },
  },
};
